import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ToastComponent } from './toast.component';

@Component({
  selector: 'app-api-error-label',
  imports: [ToastComponent, CommonModule],
  template: `
    <app-toast
      type="Error"
      [class.tw-hidden]="!error"
      [attr.aria-hidden]="!error ? 'true' : null"
    >
      @if (isString) {
        {{ error }}
      } @else {
        @if (error?.status === 403) {
          Forbidden request
        } @else if (error?.status === 500) {
          {{ error.error ? 'An error has occurred' : 'Server unavailable' }}
        } @else if (error?.status === 400) {
          <div class="tw-flex tw-flex-col tw-gap-2">
            @for (error of getValidationErrors(); track error) {
              <div>{{ error }}</div>
            }
          </div>
        } @else {
          An error has occurred
        }
      }
    </app-toast>
  `,

  styles: ``,
})
export class ApiErrorLabelComponent {
  @Input()
  error: any;

  get isString(): boolean {
    return typeof this.error === 'string';
  }

  getValidationErrors(): string[] {
    const result: string[] = [];
    const obj = this.error?.error?.errors;
    for (const a in obj) {
      result.push(obj[a][0]);
    }

    return result;
  }
}
